import { gql, useMutation } from "@apollo/client";
import { ID } from "src/types";
import { PsychoedVisibilityEnum } from "src/types/psychoed";

const UpdatePsychoedMutation = gql`
  mutation UpdatePsychoedInfo(
    $psychoedId: ID!
    $name: String
    $description: String
    $estimatedMinutes: Int
    $thumbnail: ID
    $visibility: PsychoedVisibilityEnum
  ) {
    updatePsychoedInfo(
      psychoedId: $psychoedId
      name: $name
      description: $description
      estimatedMinutes: $estimatedMinutes
      thumbnail: $thumbnail
      visibility: $visibility
    ) {
      id
    }
  }
`;

export const useUpdatePsychoedInfo = () =>
  useMutation<
    { updatePsychoedInfo: { id: ID } },
    {
      psychoedId: ID;
      thumbnail?: ID | null;
      name?: string;
      description?: string;
      estimatedMinutes?: number;
      visibility?: PsychoedVisibilityEnum;
    }
  >(UpdatePsychoedMutation);

const ArchivePsychoedMutation = gql`
  mutation ArchivePsychoed($psychoedId: ID!) {
    archivePsychoed(psychoedId: $psychoedId) {
      id
    }
  }
`;

const UnarchivePsychoedMutation = gql`
  mutation UnarchivePsychoed($psychoedId: ID!) {
    unarchivePsychoed(psychoedId: $psychoedId) {
      id
    }
  }
`;

const PublishPsychoedMutation = gql`
  mutation PublishPsychoed($psychoedId: ID!) {
    publishPsychoed(psychoedId: $psychoedId) {
      id
    }
  }
`;

export const useArchivePsychoed = () =>
  useMutation<{ archivePsychoed: { id: ID } }, { psychoedId: ID }>(ArchivePsychoedMutation, {
    refetchQueries: ["PsychoedQuery"],
  });

export const useUnarchivePsychoed = () =>
  useMutation<{ unarchivePsychoed: { id: ID } }, { psychoedId: ID }>(UnarchivePsychoedMutation, {
    refetchQueries: ["PsychoedQuery"],
  });

export const usePublishPsychoed = () =>
  useMutation<{ publishPsychoed: { id: ID } }, { psychoedId: ID }>(PublishPsychoedMutation, {
    refetchQueries: ["PsychoedQuery"],
  });

const CreatePsychoedMutation = gql`
  mutation AddPsychoed($name: String!, $estimatedMinutes: Int!, $description: String) {
    addPsychoed(name: $name, estimatedMinutes: $estimatedMinutes, description: $description) {
      id
    }
  }
`;

export const useCreatePsychoed = () =>
  useMutation<
    { addPsychoed: { id: ID } },
    { name: string; estimatedMinutes?: number; description: string }
  >(CreatePsychoedMutation, { refetchQueries: ["AllPsychoeds"] });

const ClonePsychoedMutation = gql`
  mutation ClonePsychoed($psychoedId: ID!, $newName: String) {
    clonePsychoed(psychoedId: $psychoedId, newName: $newName) {
      id
    }
  }
`;

export const useClonePsychoed = () =>
  useMutation<{ clonePsychoed: { id: ID } }, { psychoedId: ID; newName?: ID }>(
    ClonePsychoedMutation,
  );
